<template>
  <v-card flat>
    <v-divider class="my-4" />
    <v-row no-gutters>
      <!-- Sidebar / Tabs -->
      <v-col cols="auto" class="sidebar-col">
        <v-tabs
          v-model="tab"
          vertical
          background-color="transparent"
          grow
        >
          <v-tab href="#contratacion_regimenes"
            @click="actualizarItems('contratacion_regimenes')"
          >
            Régimen de <br> Contratación 
          </v-tab>

          <v-tab href="#rh_areas"
            @click="actualizarItems('rh_areas')"
          >
            Tipo de Puesto
          </v-tab>

          <v-tab href="#tipo_puestos"
            @click="actualizarItems('tipo_puestos')"
          >
            Categoría<br>Organizacional
          </v-tab>

          <v-tab href="#rh_conducir_licencia_tipos"
            @click="actualizarItems('rh_conducir_licencia_tipos')"
          >
            Tipos de Licencia <br> para Conducir
          </v-tab>

          <v-tab href="#rh_conocimiento_dominio_niveles"
            @click="actualizarItems('rh_conocimiento_dominio_niveles')"
          >
            Niveles de Dominio <br> de Conocimientos
          </v-tab>

          <v-tab href="#rh_escolaridades"
            @click="actualizarItems('rh_escolaridades')"
          >
            Escolaridades
          </v-tab>

          <v-tab href="#rh_idiomas"
            @click="actualizarItems('rh_idiomas')"
          >
            Idiomas
          </v-tab>

          <v-tab href="#rh_idioma_niveles"
            @click="actualizarItems('rh_idioma_niveles')"
          >
            Niveles de Idioma
          </v-tab>

          <v-tab href="#rh_kpi_periodicidades"
            @click="actualizarItems('rh_kpi_periodicidades')"
          >
            Periodicidades <br> de KPI
          </v-tab>

          <v-tab href="#rh_viaje_destinos"
            @click="actualizarItems('rh_viaje_destinos')"
          >
            Destinos de Viaje
          </v-tab>

          <v-tab href="#rh_viaje_motivos"
            @click="actualizarItems('rh_viaje_motivos')"
          >
            Motivos de Viaje
          </v-tab>

          <v-tab href="#rh_viaje_periodicidades"
            @click="actualizarItems('rh_viaje_periodicidades')"
          >
            Periodicidades <br> de Viaje
          </v-tab>

          <v-tab href="#expediente_requisitos"
            @click="actualizarItems('expediente_requisitos')"
          >
            Documentos <br> Expediente Personal
          </v-tab>
        </v-tabs>
      </v-col>

      <!-- Contenido -->
      <v-col>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="contratacion_regimenes">
            <v-card flat>
              <contratacion-regimenes ref="contratacion_regimenes" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="tipo_puestos">
            <v-card flat>
              <tipo-puestos ref="tipo_puestos" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_areas">
            <v-card flat>
              <rh-areas ref="rh_areas" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_conducir_licencia_tipos">
            <v-card flat>
              <rh-conducir-licencia-tipos ref="rh_conducir_licencia_tipos" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_conocimiento_dominio_niveles">
            <v-card flat>
              <rh-conocimiento-dominio-niveles ref="rh_conocimiento_dominio_niveles" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_escolaridades">
            <v-card flat>
              <rh-escolaridades ref="rh_escolaridades" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_idiomas">
            <v-card flat>
              <rh-idiomas ref="rh_idiomas" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_idioma_niveles">
            <v-card flat>
              <rh-idioma-niveles ref="rh_idioma_niveles" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_kpi_periodicidades">
            <v-card flat>
              <rh-kpi-periodicidades ref="rh_kpi_periodicidades" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_viaje_destinos">
            <v-card flat>
              <rh-viaje-destinos ref="rh_viaje_destinos" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_viaje_motivos">
            <v-card flat>
              <rh-viaje-motivos ref="rh_viaje_motivos" />
            </v-card>
          </v-tab-item>

          <v-tab-item value="rh_viaje_periodicidades">
            <v-card flat>
              <rh-viaje-periodicidades ref="rh_viaje_periodicidades" />
            </v-card>
          </v-tab-item>


          <v-tab-item value="expediente_requisitos">
            <v-card flat>
              <expediente-requisitos ref="expediente_requisitos" />
            </v-card>
          </v-tab-item>

        </v-tabs-items>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ContratacionRegimenes from './Catalogos/ContratacionRegimenes.vue'
import TipoPuestos from './Catalogos/TipoPuestos.vue'
import RHAreas from './Catalogos/RHAreas.vue'
import RHConducirLicenciaTipos from './Catalogos/RHConducirLicenciaTipos.vue'
import RHConocimientoDominioNiveles from './Catalogos/RHConocimientoDominioNiveles.vue'
import RHEscolaridades from './Catalogos/RHEscolaridades.vue'
import RHIdiomas from './Catalogos/RHIdiomas.vue'
import RHIdiomaNiveles from './Catalogos/RHIdiomaNiveles.vue'
import RHKPIPeriodicidades from './Catalogos/RHKPIPeriodicidades.vue'
import RHViajeDestinos from './Catalogos/RHViajeDestinos.vue'
import RHViajeMotivos from './Catalogos/RHViajeMotivos.vue'
import RHViajePeriodicidades from './Catalogos/RHViajePeriodicidades.vue'
import ExpedienteRequisitos from './Catalogos/ExpedienteRequisitos.vue'

import { mapState } from 'vuex'

export default {
  components: {
    'contratacion-regimenes': ContratacionRegimenes,
    'tipo-puestos': TipoPuestos,
    'rh-areas': RHAreas,
    'rh-conducir-licencia-tipos': RHConducirLicenciaTipos,
    'rh-conocimiento-dominio-niveles': RHConocimientoDominioNiveles,
    'rh-escolaridades': RHEscolaridades,
    'rh-idiomas': RHIdiomas,
    'rh-idioma-niveles': RHIdiomaNiveles,
    'rh-kpi-periodicidades': RHKPIPeriodicidades,
    'rh-viaje-destinos': RHViajeDestinos,
    'rh-viaje-motivos': RHViajeMotivos,
    'rh-viaje-periodicidades': RHViajePeriodicidades,
    'expediente-requisitos': ExpedienteRequisitos,
  },
  data: () => ({
    tab: 'contratacion_regimenes',
    sidebarExpanded: false
  }),
  computed: {
    ...mapState(['ids_vistas', 'vinculado']),
    // Anchos en px (colapsado/expandido); ajusta a tu gusto
    sidebarCollapsedPx () { return this.$vuetify.breakpoint.smAndDown ? 100 : 200 },
    sidebarExpandedPx () { return this.$vuetify.breakpoint.smAndDown ? 140 : 320 },


    sidebarCurrentPx () {
      return this.sidebarExpandedPx;
      //return this.sidebarExpanded ? this.sidebarExpandedPx : this.sidebarCollapsedPx
    },

    sidebarStyle () {
      // Transición suave del ancho de la columna izquierda
      return {
        flex: `0 0 ${this.sidebarCurrentPx}px`,
        maxWidth: `${this.sidebarCurrentPx}px`,
        transition: 'flex-basis .25s ease, max-width .25s ease'
      }
    },
    contentStyle () {
      // El contenido ocupa el resto del ancho (sin saltos)
      return {
        flex: '1 1 auto',
        maxWidth: 'calc(100% - var(--sidebar-w, 0px))',
        // sincroniza una CSS var para evitar reflows extra
        '--sidebar-w': `${this.sidebarCurrentPx}px`,
        transition: 'max-width .25s ease'
      }
    }
  },
  mounted () {
    this.actualizarItems(this.tab)
  },
  methods: {
    mostrarVista (id_vista) {
      if (!this.ids_vistas || this.ids_vistas.length === 0) return false
      return this.ids_vistas.indexOf(id_vista) >= 0
    },
    getItems () {
      this.actualizarItems(this.tab)
    },
    actualizarItems (refName) {
      const r = this.$refs[refName]
      if (r && typeof r.getItems === 'function') r.getItems()
    }
  }
}
</script>
<style scoped>
/* Asegura que el v-tabs use todo el alto disponible en la columna */
.sidebar-col,
.sidebar-col .v-tabs {
  height: 100%;
}
</style>